"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectToQueryString = void 0;
function objectToQueryString(obj, prependQuestion = true) {
    return obj
        ? `${prependQuestion ? "?" : ""}${Object.keys(obj)
            .map(function (key) {
            if (typeof obj[key] === "boolean") {
                return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key].toString());
            }
            if (obj[key]) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
            }
            return "";
        })
            .filter(Boolean)
            .join("&")}`
        : "";
}
exports.objectToQueryString = objectToQueryString;
